import { Button, Popconfirm } from "antd";
import { isPermissionPresent } from "../../../../utilities/generalUtility";
import K from "../../../../utilities/constants";
import { DefaultColumnOptions } from "../../../../hooks/useDataGrid/options";

const phoneExtRenderer = (params) => params.data.phoneExt ?? K.NullPlaceholder;

const jobTitleRenderer = (params) => params.data.jobTitle ?? K.NullPlaceholder;

const EditPermissions = [K.Permissions.EditJobHiringManagers];

const actionColumnRenderer =
  (editRecord, handleActivate, roles) => (params) => {
    return (
      <>
        {isPermissionPresent(EditPermissions, roles) && (
          <Button
            type="link"
            onClick={() => {
              editRecord(params.data);
            }}
            className="text-primary-light"
          >
            Edit
          </Button>
        )}
        {isPermissionPresent(K.Permissions.ActivateUser, roles) &&
          (params.data.isActive ? (
            <Popconfirm
              title="Are you sure you'd like to Deactivate this User?"
              onConfirm={() => {
                handleActivate(params.data.id, 0);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button className="text-primary-light" type="link">
                Deactivate
              </Button>
            </Popconfirm>
          ) : (
            <Button
              type="link"
              className="text-primary-light"
              onClick={() => handleActivate(params.data.id, 1)}
            >
              Activate
            </Button>
          ))}
      </>
    );
  };

export const getColumns = (roles, editRecord, handleActivate) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Full Name",
    field: "name",
    sortable: true,
    sort: "asc",
    tooltipField: "name",
  },
  {
    headerName: "Email",
    field: "email",
    sortable: true,
    tooltipField: "email",
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    sortable: true,
    tooltipField: "jobTitle",
    tooltipComponent: jobTitleRenderer,
    cellRenderer: jobTitleRenderer,
  },
  {
    headerName: "Phone Number",
    field: "phone",
    sortable: true,
    tooltipField: "phone",
  },
  {
    headerName: "Phone Ext",
    field: "phoneExt",
    sortable: true,
    tooltipField: "phoneExt",
    cellRenderer: phoneExtRenderer,
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(
      [...EditPermissions, K.Permissions.ActivateUser],
      roles,
    ),
    cellRenderer: actionColumnRenderer(editRecord, handleActivate, roles),
    width: 200,
  },
];
